export const html = (templateStrings, ...substitutions) => {
  let result = "";

  for (let i = 0; i < templateStrings.length; i++) {
    result += templateStrings[i];
    if (i < substitutions.length) result += substitutions[i];
  }

  return result;
};

export const getElementByIdFactory = shadow => id => {
  const el = shadow.getElementById(id);
  if (el === null) throw new Error(`#${id} is null`);
  return el;
};

export const querySelectorFactory = shadow => selector => {
  // const test = shadow.querySelector("tbody");
  const el = shadow.querySelector(selector);
  if (el === null) throw new Error(`${selector} is null`);
  return el;
};

export const queryTemplateFactory = template => selector => {
  const el = template.querySelector(selector);
  if (el === null) throw new Error(`${selector} is null`);
  return el;
};

export const createShadowRoot = (element, template) => {
  element.attachShadow({ mode: "open" });
  const root = element.shadowRoot;
  if (root === null) throw new Error("root is null");

  root.appendChild(template.content.cloneNode(true));

  const querySelector = querySelectorFactory(root);
  const getElementById = getElementByIdFactory(root);

  return {
    root,
    querySelector,
    getElementById,
  };
};
